// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-0a321375]{position:relative;cursor:pointer}.badge[data-v-0a321375]{-webkit-transition:none;transition:none;background:red;position:absolute;top:-3px;right:0;font-size:.7em}", ""]);
// Exports
module.exports = exports;
